module.exports = __webpack_public_path__ + "img/ke.01b24012.svg";